"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyboardControlls = useKeyboardControlls;
const react_1 = __importDefault(require("react"));
const ESCAPE_KEYCODE = 27;
const ARROW_LEFT_KEYCODE = 37;
const ARROW_RIGHT_KEYCODE = 39;
function useKeyboardControlls({ onArrowLeft, onArrowRight, onEscape, }) {
    const handleKeydown = react_1.default.useCallback((e) => {
        if (e.keyCode === ESCAPE_KEYCODE) {
            onEscape();
        }
        if (e.keyCode === ARROW_LEFT_KEYCODE) {
            onArrowLeft();
        }
        if (e.keyCode === ARROW_RIGHT_KEYCODE) {
            onArrowRight();
        }
    }, [onArrowLeft, onArrowRight, onEscape]);
    react_1.default.useEffect(() => {
        window.addEventListener('keydown', handleKeydown);
        return () => {
            window.removeEventListener('keydown', handleKeydown);
        };
    }, [handleKeydown]);
}
